const awsAmplify = {
    "aws_project_region": process.env.REACT_APP_REGION,
    "aws_cognito_identity_pool_id": process.env.REACT_APP_IDENTITY_POOL_ID,
    "aws_cognito_region": process.env.REACT_APP_REGION,
    "aws_user_pools_id": process.env.REACT_APP_USER_POOL_ID,
    "aws_user_pools_web_client_id": process.env.REACT_APP_CLIENT_ID,
    "oauth": {
        "domain": process.env.REACT_APP_COGNITO_DOMAIN,
        "scope": ["email", "openid", "profile"],
        "redirectSignIn": process.env.REACT_APP_REDIRECT_URI,
        "redirectSignOut": process.env.REACT_APP_LOGOUT_URI,
        "responseType": "code"
    },
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_cloud_logic_custom": [
        {
            "name": process.env.REACT_APP_AMPLIFY_API_ENDPOINT_NAME,
            "endpoint": process.env.REACT_APP_AMPLIFY_LAMBDA_ENDPOINT,
            "region": process.env.REACT_APP_REGION
        }
    ]
};

export default awsAmplify;
